/**
 * Search Section JavaScript
 * Enhances the search form with validation and interaction features
 */

class SearchForm {
  constructor() {
    this.form = document.querySelector('.search-form');
    if (!this.form) return;
    
    this.selects = this.form.querySelectorAll('select.form-control');
    this.submitButton = this.form.querySelector('.search-button');
    
    this.init();
  }
  
  init() {
    // Initialize event listeners
    this.initSelectStyles();
    this.initFormValidation();
    
    console.log('Search form initialized');
  }
  
  initSelectStyles() {
    // Add change event listeners to all select fields to handle styling
    this.selects.forEach(select => {
      // Initial check for pre-selected options
      this.updateSelectStyle(select);
      
      // Add change event listener
      select.addEventListener('change', () => {
        this.updateSelectStyle(select);
      });
    });
  }
  
  updateSelectStyle(select) {
    // Add a class to the parent when an option is selected (not the default)
    const hasValue = select.value !== '';
    select.parentElement.classList.toggle('has-value', hasValue);
  }
  
  initFormValidation() {
    // Add form submission validation
    if (this.form && this.submitButton) {
      this.form.addEventListener('submit', (e) => {
        // Basic validation - can be expanded as needed
        const isValid = this.validateForm();
        
        if (!isValid) {
          e.preventDefault();
          this.showValidationError();
        }
      });
    }
  }
  
  validateForm() {
    // Simple validation - at least one field must have a value
    let isValid = false;
    
    this.selects.forEach(select => {
      if (select.value !== '') {
        isValid = true;
      }
    });
    
    return isValid;
  }
  
  showValidationError() {
    // Show validation error message
    // This could be enhanced with more specific error messages
    const errorMessage = document.createElement('div');
    errorMessage.className = 'search-error-message';
    errorMessage.textContent = 'Please select at least one search criteria';
    
    // Remove any existing error messages
    const existingError = this.form.querySelector('.search-error-message');
    if (existingError) {
      existingError.remove();
    }
    
    // Add the error message before the submit button
    this.submitButton.parentElement.insertBefore(errorMessage, this.submitButton);
    
    // Auto-remove the error after 5 seconds
    setTimeout(() => {
      const error = this.form.querySelector('.search-error-message');
      if (error) {
        error.remove();
      }
    }, 5000);
  }
}

// Initialize the search form when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new SearchForm();
});
